import { createFileRoute, Outlet } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';
import { ProjectSocAutomationProvider } from '@views/SocAutomation/context/ProjectSocAutomationProvider';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/soc-automations')({
  beforeLoad: () => getTitleContextSlice('Automations'),
  staticData: {
    owner: CodeOwner.SWB,
  },
  component: () => (
    // Scope the threats/asoc SOAR app to alert + incident entities. User / identity_finding
    // playbooks belong to the Identities app (idnp-automations, scoped to USER/IDENTITY_FINDING).
    // Without this, the shared Playbooks/AutomationRules/Templates surfaces show every entity type,
    // because their only entity filter is matchesEntityScope(entityType, entityScope).
    <ProjectSocAutomationProvider entityScope={['ALERT', 'INCIDENT']}>
      <Outlet />
    </ProjectSocAutomationProvider>
  ),
});
